import {ReceivePackageActions} from "../actions/ReceivePackageActions";
import {Endpoints} from "../../utils/network/Enpoints";
import {axiosPOST} from "../../utils/network/NetworkUtils";

export function inductPackage(dispatcher, packageId, inductLocation, isVolumetricScan) {
    const requestData = {
        "trackingId": packageId,
        "inductLocation": inductLocation,
        "isVolumetricPackage": isVolumetricScan
    };
    postInductPackage(dispatcher, requestData);
}


async function postInductPackage(dispatcher, requestData) {
    try {
        const response = await axiosPOST("InductPackage", Endpoints.POST_INDUCT_PACKAGE, requestData);
        if (response != null) {
            dispatcher({
                type: ReceivePackageActions.INDUCT_PACKAGE_RESPONSE,
                inductState: {
                    responseStatus: response.data.userOutput.displayOutput.responseStatus,
                    responseCode: response.data.userOutput.displayOutput.responseCode,
                    itemId: response.data.trackingId,
                    soundType: response.data.userOutput.audioCueOutput.soundType,
                    salPrinterOutput: response.data.userOutput.salPrintOutput.AVERY_PRINTER
                }
            });
        }
        else {
            dispatcher({
                type: ReceivePackageActions.INDUCT_PACKAGE_RESPONSE_ERROR,
                inductState: {isApiError: true}
            });
        }

    } catch (error) {
        let inductState = {isApiError: true};

        // See: https://github.com/axios/axios/issues/383#issuecomment-234079506
        if (!error.status) {
            inductState = {isInternetNotPresent: true};
        }
        else if (error.status === "COMP_USER_NOT_FOUND") {
            inductState = {isUserNotAuthorized: true};
        }
        dispatcher({
            type: ReceivePackageActions.INDUCT_PACKAGE_RESPONSE_ERROR,
            inductState: inductState
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/receivePackage/network/ReceivePackageNetworkAPI.js